import { createSlice } from '@reduxjs/toolkit'

export interface IMatchListResponsesDataState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    searchValue: string | null
    filters?: any
    sort?: any
    projection?: any
    needPopulate: boolean
    populates?: any
    selectedRowKeys?: string[]
}

const initialState: IMatchListResponsesDataState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    searchValue: null,
    filters: {},
    sort: { status: -1, createdAt: 1 },
    projection: [],
    needPopulate: true,
    selectedRowKeys: [],
    populates: [
        { path: 'sharedWithContact', select: 'firstname lastname email' },
        {
            path: 'sharedWithCompany',
            select: '_id userType website img name updatedAt logo matchingPercentage matchingSuggestions'
        }
    ]
}

const matchListResponsesSlice = createSlice({
    name: 'ui/match-list-responses',
    initialState,
    reducers: {
        onChangePagination(state, acion) {
            state.pagination = { ...state.pagination, ...acion.payload }
        },
        onChangeSearch(state, action) {
            state.searchValue = action.payload
        },
        onChangeTotal(state, action) {
            state.pagination = { ...state.pagination, total: action.payload }
        },
        onChangeSelectedRows(state, action) {
            state.selectedRowKeys = action.payload
        }
    }
})

export const matchListResponsesActions = matchListResponsesSlice.actions
export default matchListResponsesSlice.reducer
